import { Dispatch } from "PFApp/search/search_context";
import { getAttribute } from "PFCore/helpers/get_attribute";
import { useDebounce } from "PFCore/helpers/use_debounce";
import useIsPermittedTo from "PFCore/helpers/use_is_permitted_to";
import { NormalizedKeyword } from "PFReducers/search_reducer/helpers/normalize_keywords";
import { SEARCH_ACTIONS, SEARCH_ASYNC_ACTIONS } from "PFReducers/search_reducer/search_reducer";
import { CurrentProfile, CustomType, MyAccountInfo, PermissionRule } from "PFTypes";
import { useEffect } from "react";
import { NavigateFunction } from "react-router";

export const useRedirectIfNotPermitted = (
  currentProfile: CurrentProfile,
  navigate: NavigateFunction
): void => {
  const isPermittedTo = useIsPermittedTo(currentProfile);

  useEffect(() => {
    if (!isPermittedTo(PermissionRule.ProfileList)) {
      navigate("/");
    }
  }, [isPermittedTo, navigate]);
};

export const useSyncAvailableTemplates = (dispatch: Dispatch, myAccountInfo: MyAccountInfo): void => {
  useEffect(() => {
    const availableTemplates = myAccountInfo.templates.filter(
      (template) => !template.hidden && template.read_permitted
    );
    dispatch({ type: SEARCH_ACTIONS.SET_AVAILABLE_TEMPLATES, payload: { availableTemplates } });
    dispatch({ type: SEARCH_ACTIONS.SET_ACTIVITIES_PAGINATION, payload: { availableTemplates } });
    dispatch({ type: SEARCH_ACTIONS.SEARCH_SET_TYPES, payload: { myAccountInfo } });

    return () => {
      dispatch({ type: SEARCH_ACTIONS.SEARCH_RESET_STATE });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

type SyncSuggestedKeywordsArgs = {
  dispatch: Dispatch;
  trimmedTerm: string;
  tab: string;
  term: string;
  choosenKeywords: NormalizedKeyword[];
  matchTypes: CustomType[];
  filterTypes: CustomType[];
};

export const useSyncSuggestedKeywords = ({
  dispatch,
  trimmedTerm,
  tab,
  term,
  choosenKeywords,
  matchTypes,
  filterTypes
}: SyncSuggestedKeywordsArgs): void => {
  useEffect(
    useDebounce(() => {
      if (!matchTypes.length && !filterTypes.length) {
        return;
      }
      const type = SEARCH_ASYNC_ACTIONS.SEARCH_FETCH_SUGGESTED_KEYWORDS;
      dispatch({
        type,
        payload: { choosenKeywords, term, matchTypes, filterTypes }
      });
    }, 500),
    [
      trimmedTerm,
      tab,
      choosenKeywords.map((keyword) => `${getAttribute(keyword, "globalId")},${keyword.id}`).join(":"),
      matchTypes,
      filterTypes
    ]
  );
};
